// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1eMH0JelEjC7E6 {\n  display: block;\n  margin-top: 8px;\n  margin-bottom: 4px;\n}\n._3s5eh71aPHXvGi {\n  font-size: 12px;\n  color: #6B778C;\n}\n._3s5eh71aPHXvGi a {\n  color: inherit;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationSupplements": "_1eMH0JelEjC7E6",
	"quotaSupplementText": "_3s5eh71aPHXvGi"
};
export default ___CSS_LOADER_EXPORT___;
